export default __webpack_public_path__ + "static/media/img6.8df18e18.png";